import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { useSidebar } from '../context/SidebarContext';
import { dataImportExportService } from '../services/api';
import '../styles/layout.scss';
import '../styles/users.scss';

export const DataImportExportPage: React.FC = () => {
  const [familyNamesFile, setFamilyNamesFile] = useState<File | null>(null);
  const [usersFile, setUsersFile] = useState<File | null>(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const { toggleSidebar } = useSidebar();

  const handleExport = async () => {
    setError('');
    setMessage('');
    setIsExporting(true);

    try {
      await dataImportExportService.exportData();
      setMessage('File export đã được tải xuống.');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Không thể export dữ liệu.');
    } finally {
      setIsExporting(false);
    }
  };

  const handleImport = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!familyNamesFile || !usersFile) {
      setError('Vui lòng chọn cả hai file FamilyNames.csv và Users.csv.');
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('familyNamesFile', familyNamesFile);
      formData.append('usersFile', usersFile);

      const response = await dataImportExportService.importData(formData);
      if (response.success) {
        setMessage(
          `Import thành công: ${response.data.familyNamesImported} dòng họ, ${response.data.usersImported} người dùng.`
        );
        setFamilyNamesFile(null);
        setUsersFile(null);
      } else {
        setError(response.message || 'Không thể import dữ liệu.');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Không thể import dữ liệu.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="main-content">
        <div className="header">
          <button className="hamburger-btn" onClick={toggleSidebar} aria-label="Toggle sidebar">
            <i className="fas fa-bars"></i>
          </button>
          <h1>
            <i className="fas fa-file-export"></i> Export / Import dữ liệu
          </h1>
        </div>

        <div className="content-area">
          {message && <div className="alert alert-success">{message}</div>}
          {error && <div className="alert alert-danger">{error}</div>}

          <div className="users-container">
            <div className="users-header">
              <h2>Export dữ liệu</h2>
            </div>

            <div className="card">
              <p>Bấm nút bên dưới để xuất toàn bộ dữ liệu hiện tại từ database ra file ZIP chứa FamilyNames.csv và Users.csv.</p>
              <button
                className="btn btn-primary"
                onClick={handleExport}
                disabled={isExporting}
              >
                {isExporting ? 'Đang xuất...' : 'Xuất dữ liệu'}
              </button>
            </div>

            <div className="users-header" style={{ marginTop: '24px' }}>
              <h2>Import dữ liệu</h2>
            </div>

            <div className="card">
              <form onSubmit={handleImport}>
                <div className="form-group">
                  <label>File FamilyNames.csv</label>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => setFamilyNamesFile(e.target.files?.[0] ?? null)}
                  />
                </div>
                <div className="form-group">
                  <label>File Users.csv</label>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => setUsersFile(e.target.files?.[0] ?? null)}
                  />
                </div>
                <p className="note">
                  Import sẽ xoá toàn bộ dữ liệu hiện tại trước khi nhập lại từ CSV.
                </p>
                <button className="btn btn-primary" type="submit" disabled={isLoading}>
                  {isLoading ? 'Đang import...' : 'Import dữ liệu'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
